export default "<span [attr.class]=\"cssClass\">{{ money.toStringCompactWithCoin() }}</span>\n"